import styled, { css } from 'styled-components';

import { AltBuyboxContainerProps } from './types';

// Default styles for the container as a CSS template literal
const defaultStyles = css`
  z-index: 2;
  background-color: #ffffff;
  border: 1px solid #d5d9d9;
  border-radius: 18px;
  flex-direction: column;
  width: calc(40%);
  max-width: 600px;
  min-width: 400px;
  margin-top: 40px;
  padding: 4px 24px 0px 24px;
  #invite-platform-trigger {
    width: 100%;
  }
`;

const setBorders = (props: AltBuyboxContainerProps) => {
  const border = props.border;
  const borderBottom = props.borderBottom;
  const borderLeft = props.borderLeft;
  const borderRight = props.borderRight;
  const borderTop = props.borderTop;
  const borderRadius = props.borderRadius;
  return css`
    border: ${border};
    border-bottom: ${borderBottom};
    border-left: ${borderLeft};
    border-right: ${borderRight};
    border-top: ${borderTop};
    border-radius: ${borderRadius};
  `;
};

const setFont = (props: AltBuyboxContainerProps) => {
  const color = props.color;
  const fontFamily = props.fontFamily;
  const fontSize = props.fontSize;
  const fontStyle = props.fontStyle;
  const fontWeight = props.fontWeight;
  const lineHeight = props.lineHeight;
  const textDecoration = props.textDecoration;
  return css`
    color: ${color};
    font-family: ${fontFamily};
    font-size: ${fontSize};
    font-style: ${fontStyle};
    font-weight: ${fontWeight};
    line-height: ${lineHeight};
    text-decoration: ${textDecoration};
  `;
};

const setSizing = (props: AltBuyboxContainerProps) => {
  const height = props.height;
  const margin = props.margin;
  const padding = props.padding;
  const width = props.width;
  const minWidth = props.minWidth;
  const maxWidth = props.maxWidth;
  const minHeight = props.minHeight;
  const maxHeight = props.maxHeight;
  const gap = props.gap;
  return css`
    height: ${height};
    margin: ${margin};
    padding: ${padding};
    width: ${width};
    min-width: ${minWidth};
    max-width: ${maxWidth};
    min-height: ${minHeight};
    max-height: ${maxHeight};
    gap: ${gap};
  `;
};

const setTextAlignment = (props: AltBuyboxContainerProps) => {
  const textAlign = props.textAlign;
  const verticalAlign = props.verticalAlign;
  return css`
    text-align: ${textAlign};
    vertical-align: ${verticalAlign};
  `;
};

const setBackgroundColor = (props: AltBuyboxContainerProps) => {
  const backgroundColor = props.backgroundColor;
  return css`
    background-color: ${backgroundColor};
  `;
};

export const StyledAltBuyboxContainer = styled.div<AltBuyboxContainerProps>`
  /* Apply default styles first */
  ${defaultStyles}

  /* Apply any props-based styles that will override defaults */
  ${setBorders}
  ${setFont}
  ${setSizing}
  ${setTextAlignment}
  ${setBackgroundColor}
`;

export const StyledMobileAltBuyboxContainer = styled.div<AltBuyboxContainerProps>`
  #invite-platform-trigger {
    max-width: 550px;
  }

  /* Apply any props-based styles that will override defaults */
  ${setBorders}
  ${setFont}
  ${setSizing}
  ${setTextAlignment}
  ${setBackgroundColor}
`;
